export const settingsRouteLinks = {
    root: "/settings",
    featureFlags: "/settings/feature-flags",
    instanceEnvironmentVariables: "/settings/instance-environment-variables",
};